import React from 'react';
import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';

export const AboutPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50">
      <div className="max-w-3xl mx-auto p-8">
        <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg p-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-6">About Simiyah</h1>

          <div className="prose prose-lg">
            <p className="text-gray-800 mb-6">
              <strong>Simiyah</strong> is a growing suite of smart educational tools designed to support modern teaching and learning. 
              Each tool within Simiyah focuses on solving real challenges faced by educators and learners in a practical, accessible way. 
              Whether you're organizing lessons, generating content, or enhancing student engagement, Simiyah brings simple, effective solutions to your fingertips.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Why Simiyah?</h2>
            <ul className="list-disc pl-6 space-y-2 text-gray-800">
              <li>Built for educators, by an educator</li>
              <li>Focused on usability, efficiency, and impact</li>
              <li>Continuously evolving with feedback from real users</li>
              <li>Supports both Arabic and English education contexts</li>
            </ul>

            <footer className="mt-12 pt-6 border-t border-gray-200">
              <p className="text-gray-800">
                <strong>Created by</strong><br />
                Osama S. Altiti<br />
                Learning Management Systems Administrator<br />
                📧 <a href="mailto:altiti@altiti.com" className="text-blue-600 hover:text-blue-800 transition-colors">altiti@altiti.com</a>
              </p>
            </footer>
          </div>

          <div className="mt-8">
            <Link 
              to="/"
              className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 text-white rounded-lg transition-all duration-300 shadow-md hover:shadow-lg"
            >
              <Home className="w-5 h-5" />
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};